import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const mockRoast = `Oh boy. Let's talk about this "document". 

First off, "Synergy" and "Results-driven"? Did you copy-paste this from a 2012 LinkedIn influencer's fever dream? 

Your experience section reads less like a career history and more like a grocery list written by someone who doesn't know how to cook. "Managed team of 5" — managed them to do what? Survive the day? 

And the formatting... it's giving "I learned Word in 1998 and never looked back." Recruiters aren't reading this, they're using it to calibrate their shredders. 

You seem like a nice person, but this resume is actively sabotaging your life. Want me to actually fix this disaster before you send it to another human?`;

export default function RoastView({ onUpgrade }) {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="w-full max-w-2xl mx-auto"
    >
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-rose-500/20 flex items-center justify-center">
          <span className="text-xl">😈</span>
        </div>
        <h2 className="text-2xl font-bold text-white">AI Coach (Brutal Mode)</h2>
      </div>

      <div className="glass-panel rounded-2xl p-6 md:p-8 mb-8 relative overflow-hidden">
        {/* Subtle background glow */}
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-rose-500/20 rounded-full blur-3xl" />
        
        <div className="relative z-10 space-y-4 text-slate-300 text-lg leading-relaxed font-medium">
          {mockRoast.split('\n\n').map((paragraph, idx) => (
            <motion.p 
              key={idx}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.5 }}
            >
              {paragraph}
            </motion.p>
          ))}
        </div>
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 2.5 }}
        className="glass-panel rounded-3xl p-1 relative overflow-hidden group"
      >
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-500 to-cyan-500 opacity-20 group-hover:opacity-40 transition-opacity duration-500" />
        
        <div className="bg-slate-900 rounded-[22px] p-6 text-center relative z-10 flex flex-col items-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 text-emerald-400 text-sm font-semibold mb-4 border border-emerald-500/20">
            <SafeIcon icon="Unlock" className="w-4 h-4" />
            Serious Mode Available
          </div>
          
          <h3 className="text-2xl font-bold text-white mb-2">Stop getting rejected.</h3>
          <p className="text-slate-400 mb-6 max-w-md">
            Unlock the professional, section-by-section rewrite, ATS optimization score, and exact formatting fixes you need to get hired.
          </p>
          
          <button 
            onClick={onUpgrade}
            className="w-full sm:w-auto flex items-center justify-center gap-2 bg-gradient-to-r from-emerald-500 to-cyan-500 hover:from-emerald-400 hover:to-cyan-400 text-slate-950 font-bold text-lg py-4 px-10 rounded-full transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(16,185,129,0.3)]"
          >
            Fix My Resume for $2.99
            <SafeIcon icon="ArrowRight" className="w-5 h-5" />
          </button>
          <p className="text-xs text-slate-500 mt-4">One-time payment. Instant access.</p>
        </div>
      </motion.div>
    </motion.div>
  );
}